import { isValidationObject } from './isValidationObject';
/**
 * Processes a validation rule by checking if it is a Validation object and applying any necessary transformations.
 *
 * @param {T | Validation<T>} rule - The rule to process, which can be a simple value or a Validation object.
 * @param {(value: T) => any} [transformFunc] - An optional function to transform the rule value if needed.
 * @returns - The processed rule, either as a simple value or an object with 'value' and 'message' properties.
 */
export const processValidationRule = (rule, transformFunc) => {
    if (isValidationObject(rule)) {
        return {
            value: transformFunc ? transformFunc(rule.value) : rule.value,
            message: rule.message
        };
    }
    return transformFunc ? transformFunc(rule) : rule;
};
